import { setLocales } from "@/base/locale/store";
import rpcService, { withLocalePathSegment } from "@/base/rpc/rpc-service";
import { IBaseResponse } from "@/base/rpc/rpc-types";
import { ISearchContribution, searchContribContainer } from "@/base/search";
import state from "@/base/state";
import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import * as React from "react";
import { Scrollbars } from 'react-custom-scrollbars';
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import DocContent from "./components/DocContent";
import DocNav from "./components/DocNav";
import { BOOKID } from "./configs";
import { IDocument } from "./types/doc-types";
import { getEditionInfoFromParams } from "./utils/edition";
import { getBasePathFromParam } from "./utils/urls";


const searchDocument = async (keyword: string, edition: string) => {
    const res = await rpcService.getJSON<IBaseResponse<IDocument[]>>(`/${edition}/${withLocalePathSegment(edition, state.locale)}search-docs`, {keyword, bookId: BOOKID});
    return res.data;
}

export default (props: {}) => {
    const params = TARGET === 'web' ? useParams(): {};
    React.useMemo(() => {
        searchContribContainer.addContrib(new class implements ISearchContribution{
            readonly title = 'Documents';
            async search(keyword: string) {
                const edition = getEditionInfoFromParams(params);
                const docs = await searchDocument(keyword, edition.key);
                return docs.map(d => ({
                    title: d.Title,
                    content: d.Content,
                    to: `${getBasePathFromParam(params)}/d/${d.Key}`
                }));
            }
        })
    }, []);
    const dispath = useDispatch();
    React.useEffect(() => {
        dispath(setLocales(getEditionInfoFromParams(params).locales || []));
    }, [params]);
    return (
        <Layout style={{flexDirection: 'row'}}>
            <Sider width={300} style={{
                height: 'calc(100vh - 64px)',
                padding: '1em 0 1em 1em',
                boxSizing: 'border-box',
                background: '#F5F5F5',
            }} className="app-sider">
                <Scrollbars autoHide>
                    <DocNav />
                </Scrollbars>
            </Sider>
            <Content
                className="app-content"
                style={{
                    position: 'relative',
                    margin: 0,
                    padding: 0,
                    height: 'calc(100vh - 64px)',
                    boxSizing: 'border-box',
                }}
            >
                <DocContent />
            </Content>
        </Layout>
    )
}
